import React, { useState, useRef, useEffect } from "react";
import "../../styles/admin/iqTestCard.scss";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import TooltipText from "../common/tooltipText";
import TimerSharpIcon from "@mui/icons-material/TimerSharp";

const IqTestCard = ({
  data,
  onDelete,
  handleClick,
  onEdit,
  hideActionBtn,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  const handleMenuToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(!showMenu);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(false);
    onEdit && onEdit(data);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(false);
    onDelete && onDelete(data);
  };
  const formatDateTime = (dt) => {
    if (!dt) return "--";
    try {
      const d = new Date(dt);
      if (Number.isNaN(d.getTime())) return String(dt);
      return d.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return String(dt);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  return (
    <div className="iq-test-card" onClick={handleClick}>
      <div className="iq-test-card-title-container">
        <div className="iq-test-card-title-logo">
          <div className="iq-test-card-title">
            <TooltipText
              text={data?.name || "Untitled Course"}
              className="iq-test-title-text"
              maxWidth="120"
            />
          </div>
        </div>
        {!hideActionBtn && (
          <div className="iq-test-actions" ref={menuRef}>
            <button
              className="action-btn"
              onClick={handleMenuToggle}
              aria-haspopup="menu"
              aria-expanded={showMenu}
              aria-label="iq-test actions"
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <MoreVertIcon fontSize="small" />
            </button>
            {showMenu && (
              <div
                className="iq-test-actions-menu"
                role="menu"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  className="actions-item"
                  onClick={handleEdit}
                  role="menuitem"
                >
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <EditIcon fontSize="small" /> Edit
                  </span>
                </button>
                <button
                  type="button"
                  className="actions-item danger"
                  onClick={handleDelete}
                  role="menuitem"
                >
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <DeleteIcon fontSize="small" /> Delete
                  </span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="iq-test-center-content">
        <div className="iq-test-duration-container">
          <TimerSharpIcon
            style={{ fontSize: 30, color: "var(--color-text-light)" }}
          />
          <div className="iq-test-duration-info">
            <p>DURATION</p>
            <p className="iq-test-duration-p">{data?.duration}</p>
          </div>
        </div>
  
      </div>

      <div className="iq-test-card-times">
        <span className="time-item">
          <TooltipText
            text={`Created: ${formatDateTime(data?.created_at)}` || ""}
            always
            fullWidth
            placement="bottom"
          />
        </span>
        <span className="time-item">
          <TooltipText
            text={`Updated: ${formatDateTime(data?.updated_at)}` || ""}
            always
            fullWidth
            placement="bottom"
          />
        </span>
      </div>
    </div>
  );
};

export default IqTestCard;
